module.exports = __webpack_public_path__ + "static/media/waiting-room-empty.bd187732.svg";